import React from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

export function NormalInput(props) {
  const {
    name,
    placeholder,
    type,
    required,
    styles,
    register,
    validationSchema,
    errors,
    value,
    readOnly,
    divStyles,
    icon,
    iconComponent,
  } = props;
  return (
    <div className={`${divStyles}`}>
      {icon && <>{iconComponent}</>}
      <input
        className={`py-3 appearance-none block w-full border border-[#e2e8f0] rounded px-4 leading-tight mb-3 h-[48px] ${styles}`}
        id={placeholder}
        type={type}
        placeholder={placeholder}
        required={required}
        {...register(name, validationSchema)}
        defaultValue={value}
        readOnly={readOnly}
      />

      <p className="text-red-500 text-[18px] mb-2">
        {errors && errors[name]?.type === "maxLength"
          ? errors[name]?.message
          : errors[name]?.type === "required"
          ? errors[name]?.message
          : errors[name]?.type === "minLength" && errors[name]?.message}
      </p>
    </div>
  );
}

export function PassWordInput(props) {
  const {
    name,
    placeholder,
    type,
    required,
    register,
    validationSchema,
    errors,
    eye,
    setEye,
  } = props;
  return (
    <>
      <div className="w-full px-4 border border-[#e2e8f0] flex items-center justify-between h-[48px] mb-3 bg-white rounded-md">
        <input
          className="block rounded w-full leading-tight h-full outline-none input_w_full"
          id={name}
          type={type === "password" && eye ? "text" : "password"}
          placeholder={placeholder}
          required={required}
          {...register(name, validationSchema)}
        />
        {/* eye icon */}
        {eye ? (
          <AiOutlineEye
            className="text-[#3c7fff] text-[24px] cursor-pointer"
            onClick={setEye}
          />
        ) : (
          <AiOutlineEyeInvisible
            className="text-[#3c7fff] text-[24px] cursor-pointer"
            onClick={setEye}
          />
        )}
      </div>

      <p className="text-red-500 text-[18px] mb-2">
        {errors && errors[name]?.type === "maxLength"
          ? errors[name]?.message
          : errors[name]?.type === "required"
          ? errors[name]?.message
          : errors[name]?.type === "minLength" && errors[name]?.message}
      </p>
    </>
  );
}
